// extracted by mini-css-extract-plugin
export var donateButton = "footer-module--donateButton--iN9nn";
export var footerLink = "footer-module--footerLink--MVtX3";
export var footerText = "footer-module--footerText--a1iAx";
export var menuTitle = "footer-module--menuTitle--SNy0e";